module.exports = __webpack_public_path__ + "img/gift_3.051243c1.webp";